#import "./TrainingModuleAdminFields.graphql"

mutation UpsertTrainingQuestion(
  $moduleId: ID!
  $questionId: ID
  $prompt: String!
  $explanation: String
  $options: [TrainingAnswerOptionInput!]!
) {
  upsertTrainingQuestion(
    input: {
      moduleId: $moduleId
      questionId: $questionId
      prompt: $prompt
      explanation: $explanation
      options: $options
    }
  ) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
  }
}
